import { render, staticRenderFns } from "./PreviewBookCard.vue?vue&type=template&id=dc9b4762&"
import script from "./PreviewBookCard.vue?vue&type=script&lang=js&"
export * from "./PreviewBookCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviewBookCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports